import { EntityTypes } from '@squaredup/constants';
import type { Serialised } from '@squaredup/ids';
import type { DataStreamDefinitionEntity } from 'dynamo-wrapper';

/**
 * If true, this data stream was saved by a user to a specific plugin config.
 */
export const isSavedDataStream = (
    dataStream: DataStreamDefinitionEntity | Serialised<DataStreamDefinitionEntity>
): boolean => (dataStream.parentPluginId as unknown as string)?.startsWith(EntityTypes.CONFIG);
